import {
  Box,
  Paper,
  TableContainer as TableContainerMui,
  styled,
  Button as ButtonMui,
} from '@material-ui/core'
import { MenuPopover } from 'shared'

export const TableContainer = styled(TableContainerMui)(() => ({
  boxShadow: '0px 0px 10px 2px rgba(0,0,0,0.2)',
  borderRadius: '8px',
  marginTop: '2rem',
  maxHeight: '500px',
  '& thead tr th': {
    color: '#757575',
    fontWeight: 500,
    fontSize: '1.1rem',
  },
  '& th, & td': {
    width: '25%',
    paddingLeft: '2rem',
  },
  '& tbody tr td:first-child': {
    fontWeight: 500,
    fontSize: '0.9rem',
  },
  '& thead tr th:nth-child(2)': {
    textAlign: 'center',
  },
  '& tbody tr td:nth-child(2)': {
    fontWeight: 400,
    fontSize: '0.9rem',
    textAlign: 'center',
  },
  '& tr:nth-child(even)': {
    backgroundColor: '#F5F5F5',
  },
  '& tr:hover': {
    backgroundColor: '#EFEFEF',
  },
  '& tr': {
    cursor: 'pointer',
  },
}))

export const Button = styled(ButtonMui)({
  background: '#89BD23',
  color: '#FFF',
})

export const MenuPopoverStyled = styled(MenuPopover)({
  '& .MuiPopover-paper': {
    boxShadow: 'none',
    border: '1px solid #E0E0E0',
  },
})

export const RouteGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
  gap: '1.25rem',
  marginTop: '1.5rem',
})

export const RouteCard = styled(Paper)({
  borderRadius: '12px',
  padding: '1.25rem',
  border: '1px solid #E4E8E0',
  boxShadow: '0 2px 10px rgba(38, 54, 26, .08)',
  transition: 'box-shadow .2s ease, transform .2s ease',
  '&:hover': {
    boxShadow: '0 6px 18px rgba(38, 54, 26, .14)',
    transform: 'translateY(-2px)',
  },
})

export const CapacityBar = styled(Box)({
  height: '10px',
  borderRadius: '8px',
  background: '#E8E8E8',
  overflow: 'hidden',
  margin: '.75rem 0',
  '& > div': {
    height: '100%',
    background: '#D94B43',
    borderRadius: '8px',
  },
})

export const OpenTreatmentButton = styled(ButtonMui)({
  marginTop: '1rem',
  color: '#FFF',
  backgroundColor: '#89BD23',
  boxShadow: 'none',
  textTransform: 'none',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#6F9D12',
    boxShadow: 'none',
  },
  '@media (max-width: 600px)': {
    width: '100%',
  },
})

export const HistoryButton = styled(ButtonMui)({
  minHeight: '40px',
  padding: '0 .9rem',
  color: '#416D0B',
  borderColor: '#B8C7A5',
  background: '#FFFFFF',
  boxShadow: 'none',
  textTransform: 'none',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  '&:hover': {
    borderColor: '#416D0B',
    background: '#F5F8F1',
    boxShadow: 'none',
  },
  '@media (max-width: 600px)': {
    width: '100%',
  },
})
